/**
 * Data model for googly analytics event
 * @author dame.gjorgjievski
 */
export default class GAEvent {

    category: String = null
    action: String = null
    label: String = null
    value: Object = null

    constructor(category, action, label, value) {
        this.category = category
        this.action = action
        this.label = label
        this.value = value
    }

    static Category = {
        AUTH: "Auth",
        NAV: "Navigation",
        DATA: "Data"
    }

    static Action = {
        LOGIN: "Login",
        LOGIN_ERROR: "LoginError",
        LOGOUT: "Logout",
        REGISTER: "Register",
        REGISTER_ERROR: "RegisterError",
        PROFILE_EDIT: "ProfileEdit",
        PROFILE_VIEW: "ProfileView",
        PROFILE_ERROR: "ProfileError",
        ENTITY_CREATE: "EntityCreate",
        ENTITY_CREATE_ERROR: "EntityCreateError",
        ENTITY_SEARCH: "EntitySearch",
        ENTITY_SEARCH_ERROR: "EntitySearchError",
        ENTITY_LOAD: "EntityLoad",
        ENTITY_LOAD_ERROR: "EntityLoadError",
        ENTITY_UPDATE: "EntityUpdate",
        ENTITY_UPDATE_ERROR: "EntityUpdateError",
        ENTITY_DELETE: "EntityDelete",
        ENTITY_DELETE_ERROR: "EntityDeleteError",
        LINK: "Link",
        FILE: "File",
        JOIN_SESSION: 'JoinSession',
        LEAVE_SESSION: 'LeaveSession'
    }
}